<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 vcenter">
      <h3>{{ headerText }}</h3>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:6px" />

  <div class="row top10">

    <aims-common-table
      id="mac-table"
      [dataSource]="macAddresses | async"
      [header]="header"
      [permissions]="tablePermissions"
      (rowUpdated)="handleRowUpdate($event)"
      (rowAdded)="handleRowAdd($event)"
      (rowDeleted)="handleRowDelete($event)"
      [addRowInitialObject]="addRowInitialObject"
      [defaultTableState]="defaultTableState"
      [stickyHeader]="true">

      <aims-common-table-dynamic-row id="hughesNetUserId">
        <ng-template viewMode let-element style="width:70px">
          {{ element.hughesNetUserId | getText:'hughesNetUserId':'fullName':hughesNetUsers | async}}
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
          <mat-select style="width: 150px" [formControl]="dynamicControl" required>
              <mat-option *ngFor="let u of hughesNetUsers | async" [value]="u.hughesNetUserId">
                {{ u.fullName }}
              </mat-option>
          </mat-select>
          </mat-form-field>
        </ng-template>
    </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="macAddress">
        <ng-template viewMode let-element style="width:70px">
          {{ element.macAddress }}
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <mat-form-field appearance="fill" class="editable-text-field">
          <input matInput [formControl]="dynamicControl" mask="AA:AA:AA:AA:AA:AA" name="mac"
            [ngModel]="element.macAddress"
            [patterns]="macRule"
            >
          </mat-form-field>
        </ng-template>
      </aims-common-table-dynamic-row>

    </aims-common-table>
  </div>

</div>
